export default "__VITE_ASSET__BERmb1_6__"